import EmptyMessage from './EmptyMessage'

export default EmptyMessage
